import {useState, useEffect, useCallback, useRef, useContext} from 'react'
import {ToastContainer} from 'react-toastify'
import {
    Bodies,
    Body,
    Composite,
    Engine,
    Events,
    IEventCollision,
    Render,
    Runner,
    World,
} from 'matter-js'
import axios from 'axios'
import reach_2_sound from "./sounds/reach_2.wav"
import ball_sound from "./sounds/ball.wav"
import confet_sound from "./sounds/small-victory.mp3"
import Confetti from 'react-confetti'
import {isMobile} from 'react-device-detect'

import {config, multiplierValues} from './config'
import MainLayout from './layouts/MainLayout'
import Panel from './components/BetAction'
import GameBoard from './components/GameBoard'
import styles from './plinko.module.css'
import {Context} from "../../index";
import schemapack from "schemapack";
import {confetSound,ballSound} from "./sounds/plinko_sounds";
import msgpack from "msgpack-lite";
import Spin from "../../components/UI/Spin/Spin";
import {observer} from "mobx-react-lite";
import {useNavigate} from "react-router-dom";
import {unpack, pack} from "../../Utils/forSocket";
import ErrorComponent from "../../components/UI/Error/ErrorComponent";
import PlinkoService from "./PlinkoService";
import {is} from "date-fns/locale";
import Footer from "../../components/Footer/Footer";

export const Plinko = observer(() => {
    function random(min, max) {
        const random = Math.random()
        min = Math.round(min)
        max = Math.floor(max)

        return random * (max - min) + min
    }


    const mainSchema = schemapack.build({
        event: "string",
        data: "buffer"
    })
    const {store} = useContext(Context)

    const navigate = useNavigate()

    const engine = Engine.create()
    const [isAuto, setIsAuto] = useState(false)
    const [lines, setLines] = useState(8)
    const [risk, setRisk] = useState('Low')

    const inGameBallsCount = 0
    let ballCount = 0
    const [activeBlock, setActiveBlock] = useState(-1)
    const [autoBallCount, setAutoBallCount] = useState(1)
    const [lastMultipliers, setLastMultipliers] = useState([])
    const incrementInGameBallsCount = () => {
        ballCount++;
    }
    const decrementInGameBallsCount = () => {
        ballCount--;


    }
    const [loadingPage, setLoadingPage] = useState(true)
    const {engineConfig, worldConfig, maxBallsCount} = config
    const worldWidth = worldConfig.width
    const worldHeight = worldConfig.height
    const incrementBalance = (new_balance) => {

        store.user.balance += new_balance
    }

    const [leftBallCount, setLeftBallCount] = useState(0)
    const [muted, setMuted] = useState(
        (localStorage.getItem('muted') === 'true' || isMobile) ? true : false
    )
    const muteRef = useRef(null)
    muteRef.current = muted
    const [confettiRunning, setConfettiRunning] = useState(0)
    const width = window.innerWidth;


    const height = window.innerHeight;

    const alertUser = (e) => {
        game_other_start()
        if (inGameBallsCount > 0) {
            e.preventDefault()
            alert('Do you really want to leave?')
            e.returnValue = ''
        }
    }
    async function enterGame(){
        try {


            const response = await PlinkoService.enterGame();

            if (response.status === 200) {
                const data = response.data
                if (data.redirect){
                    navigate(data.redirect)
                }
                if (data.error){
                    store.add_message(data.msg,ErrorComponent)
                }
                if (data.msg === "ok"){
                    setLoadingPage(false)
                    store.setIsLoadingComponent(false)
                }
            }
        }
        catch (e){
            console.error(e)
            store.add_message("error1",ErrorComponent)
        }

    }



    useEffect(() => {
        if (store.isAuth) {
            enterGame();
        }
    }, [store.isAuth]);


    useEffect(() => {
        window.addEventListener('beforeunload', alertUser)
        return () => {

            window.removeEventListener('beforeunload', alertUser)
        }
    }, [inGameBallsCount]) //eslint-disable-line

    useEffect(() => {


        engine.gravity.y = engineConfig.engineGravity
        const element = document.getElementById('plinko')

        const render = Render.create({
            element: element,
            bounds: {
                max: {
                    x: worldWidth,
                    y: worldHeight,
                },
                min: {
                    x: 0,
                    y: 0,
                },
            },
            options: {
                background: 'var(--primary)',
                hasBounds: true,
                width: worldWidth,
                height: worldHeight,
                wireframes: false,
            },
            engine,
        })
        const runner = Runner.create()
        Runner.run(runner, engine)
        Render.run(render)
        
        return () => {
            World.clear(engine.world, true)
            Engine.clear(engine)
            render.canvas.remove()
            render.textures = {}
        }

    }, [risk, lines, loadingPage]) //eslint-disable-line

    const pins = []

    const pinSize = 8 - lines / 4 + (lines === 8 ? 1.2 : 0)
    const widthUnit = (worldWidth - pinSize * 2) / (lines * 2 + 2)
    const heightUnit = (worldHeight - pinSize * 2) / (lines + 1)

    for (let i = 0; i < lines; i++) {
        for (let j = lines - i - 1; j <= lines - i + (i + 2) * 2; j += 2) {
            const pin = Bodies.circle(
                widthUnit * j + pinSize,
                heightUnit * (i + 2) + pinSize - 20,
                pinSize,
                {
                    label: `pin-${i}`,
                    render: {
                        fillStyle: '#CABAFF',
                    },
                    isStatic: true,
                }
            )
            pins.push(pin)
        }
    }

    const addInGameBall = () => {
        if (inGameBallsCount > maxBallsCount) return
        incrementInGameBallsCount()
    }

    const removeInGameBall = () => {
        decrementInGameBallsCount()
    }
    const game_other_start = async()=>{
        try {
            await PlinkoService.game_other();
        }
        catch (e){
            console.error(e)
            store.add_message("error1",ErrorComponent)
        }


    }
    const addBall = useCallback((ballValue,id) => {
        if (!muteRef.current) {

            ballSound.play()

        }
        addInGameBall()

        const minBallX = worldWidth / 2 + widthUnit
        const maxBallX = worldWidth / 2 - widthUnit
        const ballX = random(minBallX, maxBallX)
        const ballColor = '#ff9010'

        const ball = Bodies.circle(ballX, heightUnit, pinSize * 1.8, {
            restitution: 1,
            friction: 0.6,
            label: `ball-${ballValue}-${ballX}`,
            id: new Date().getTime(),
            id_from_db:id,
            frictionAir: 0.05,
            collisionFilter: {
                group: -1,
            },
            render: {
                fillStyle: ballColor,
            },
            isStatic: false,
        })


        Composite.add(engine.world, ball)


    }, [risk, lines, loadingPage])
    // const addBall = (ballValue) => {
    //
    //     addInGameBall()
    //
    //     const minBallX = worldWidth / 2 + widthUnit
    //     const maxBallX = worldWidth / 2 - widthUnit
    //     const ballX = random(minBallX, maxBallX)
    //     const ballColor = '#ff9010'
    //     const ball = Bodies.circle(ballX, heightUnit, pinSize * 1.8, {
    //         restitution: 1,
    //         friction: 0.6,
    //         label: `ball-${ballValue}-${ballX}`,
    //         id: new Date().getTime(),
    //         frictionAir: 0.05,
    //         collisionFilter: {
    //             group: -1,
    //         },
    //         render: {
    //             fillStyle: ballColor,
    //         },
    //         isStatic: false,
    //     })
    //
    //
    //     Composite.add(engine.world, ball)
    //
    // }


    const leftWall = Bodies.rectangle(
        worldWidth / 3 - 75,
        worldWidth / 2 - 2,
        worldWidth * 2,
        40,
        {
            angle: 90,
            render: {
                visible: false,
            },
            isStatic: true,
        }
    )
    const rightWall = Bodies.rectangle(
        worldWidth - 125,
        worldWidth / 2 - 2,
        worldWidth * 2,
        40,
        {
            angle: -90,
            render: {
                visible: false,
            },
            isStatic: true,
        }
    )
    const floor = Bodies.rectangle(0, worldWidth + 1, worldWidth * 10, 30, {
        label: 'block-1',
        render: {
            visible: false,
        },
        isStatic: true,
    })

    Composite.add(engine.world, [...pins, leftWall, rightWall, floor])

    const bet = (betValue,id,status=1) => {

        setLeftBallCount((prev) => prev - 1)
        status && addBall(betValue,id)

    }

    const onCollideWithMultiplier = async (ball, multiplier) => {

        ball.collisionFilter.group = 2

        World.remove(engine.world, ball)
        removeInGameBall()
        const ballValue = ball.label.split('-')[1]
        const startPos = ball.label.split('-')[2]
        const xPos = ball.position.x
        const target = Math.floor((xPos - pinSize) / (widthUnit * 2))

        // if (!muteRef.current) {
        //     const multiplierSound = new Audio()
        //     multiplierSound.autoplay = true
        //
        //     multiplierSound.src = reach_2_sound
        //     multiplierSound.volume = 0.2
        //
        //     multiplierSound.remove()
        // }
        const multiplierValue = multiplierValues[risk][lines / 4 - 2][target]
        setActiveBlock(-1)
        setTimeout(() => {
            setActiveBlock(target)
        }, 5)
        try {


            const increment_balance_Response = (await PlinkoService.increment_balance(+ballValue * multiplierValue, multiplierValue, ball.id_from_db)).data

            if (increment_balance_Response.msg === "ok") {
                store.user.balance = increment_balance_Response.userBalance;
            }
        }
        catch (e){
            console.error(e)
            store.add_message("error1",ErrorComponent)
        }


        setLastMultipliers((prev) => [{mul: multiplierValue, index: target}, ...prev])
        // await axios.post('http://localhost:8080/makeArray', {
        // 	line: lines,
        // 	xpos: startPos,
        // 	target: target,
        // })
        if (ballCount === 0) {
            await game_other_start()
        }
        if (multiplierValue >= 2.1) {
            setConfettiRunning(400)
            if (!muteRef.current) {

                confetSound.play()
            }
            setTimeout(() => {
                setConfettiRunning(0)
            }, 2000)
        }
    }

    const onBodyCollision = async (event) => {
        const pairs = event.pairs
        for (const pair of pairs) {
            const {bodyA, bodyB} = pair
            if (bodyB.label.includes('ball') && bodyA.label.includes('block')) {
                onCollideWithMultiplier(bodyB, bodyA)
            }
        }
    }

    const onBounceCollision = async (event) => {


        const pairs = event.pairs
        for (const pair of pairs) {
            const {bodyA, bodyB} = pair
            if (bodyB.label.includes('ball') && bodyA.label.includes('pin')) {
                const xPos = bodyA.position.x;
                const yPos = bodyA.position.y;
                let radius = pinSize;
                let bounceEffect = null;

                function animateBounce() {


                    bounceEffect !== null && World.remove(engine.world, bounceEffect);
                    bounceEffect = Bodies.circle(xPos, yPos, radius, {
                        collisionFilter: {group: -1},
                        render: {
                            fillStyle: '#fff3',
                        },
                        isStatic: true,
                    });
                    Composite.add(engine.world, bounceEffect);
                    radius = radius + pinSize / 8;
                    if (radius <= pinSize * 3) {
                        requestAnimationFrame(animateBounce);
                    } else {
                        World.remove(engine.world, bounceEffect);
                    }
                }

                animateBounce();
            }
        }
    }

    Events.on(engine, 'collisionStart', onBodyCollision)
    Events.on(engine, 'collisionStart', onBounceCollision)

    const handleSetMuted = () => {
        localStorage.setItem('muted', muted === true ? 'false' : 'true')
        setMuted((prev) => !prev)
    }

    if (loadingPage) {
        return <Spin/>
    }
    return (
        <>
        <MainLayout title="Play Blinko" className={`${styles.plinko} fadeAnimationMain`}>
            <div className="plinko-container">
                <div className="game-box">
                    <Panel
                        inGameBallsCount={inGameBallsCount}
                        onChangeLines={setLines}
                        onRunBet={bet}
                        mainSchema={mainSchema}
                        onChangeRisk={setRisk}
                        autoBallCount={autoBallCount}

                        onChangeAutoBallCount={setAutoBallCount}
                        isAuto={isAuto}
                        onChangeIsAuto={setIsAuto}
                        leftBallCount={leftBallCount}
                        onChangeLeftBallCount={setLeftBallCount}
                        muted={muted}
                        onChangeMuted={handleSetMuted}
                    />
                    <GameBoard
                        lines={lines}
                        risk={risk}
                        pinSize={pinSize}
                        activeBlock={activeBlock}
                        multiplierHistory={lastMultipliers}
                        leftBallCount={leftBallCount}
                        isAuto={isAuto}
                    />
                </div>
            </div>

            <Confetti

                width={width}
                height={height}
                gravity={0.15}
                numberOfPieces={confettiRunning}
            />

        </MainLayout>
            <Footer/>
        </>
    )

})

export default Plinko
